webpackJsonp([183369171117343],{

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(49),
	    getRawTag = __webpack_require__(96),
	    objectToString = __webpack_require__(97);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 69:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(49);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(69);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33),
	    now = __webpack_require__(99),
	    toNumber = __webpack_require__(100);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(32),
	    isObjectLike = __webpack_require__(37);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(28);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(33),
	    isSymbol = __webpack_require__(71);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _ref;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _colorManipulator = __webpack_require__(73);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Element = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Element || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func;
	
	var styles = exports.styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: 20,
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.background.default, 0.26)
	    },
	    img: {
	      maxWidth: '100%',
	      width: '100%',
	      height: 'auto'
	    }
	  };
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  alt: __webpack_require__(1).string,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Element),
	  childrenClassName: __webpack_require__(1).string,
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  component: __webpack_require__(1).oneOfType([__webpack_require__(1).string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_ComponentType)]),
	  imgProps: __webpack_require__(1).object,
	  sizes: __webpack_require__(1).string,
	  src: __webpack_require__(1).string,
	  srcSet: __webpack_require__(1).string
	};
	
	
	function Avatar(props) {
	  var alt = props.alt,
	      classes = props.classes,
	      classNameProp = props.className,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      ComponentProp = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties3.default)(props, ['alt', 'classes', 'className', 'children', 'childrenClassName', 'component', 'imgProps', 'sizes', 'src', 'srcSet']);
	
	
	  var className = (0, _classnames2.default)(classes.root, (0, _defineProperty3.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (childrenProp) {
	    if (childrenClassNameProp && _react2.default.isValidElement(childrenProp)) {
	      var _childrenClassName = (0, _classnames2.default)(childrenClassNameProp, childrenProp.props.className);
	      children = _react2.default.cloneElement(childrenProp, { className: _childrenClassName });
	    } else {
	      children = childrenProp;
	    }
	  } else if (src || srcSet) {
	    children = _react2.default.createElement('img', (0, _extends3.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  }
	
	  return _react2.default.createElement(
	    ComponentProp,
	    (0, _extends3.default)({ className: className }, other),
	    children
	  );
	}
	
	Avatar.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  component: require('prop-types').string.isRequired,
	  alt: require('prop-types').string,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Element === 'function' ? babelPluginFlowReactPropTypes_proptype_Element : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Element),
	  childrenClassName: require('prop-types').string
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', require('prop-types').oneOfType([require('prop-types').string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType)])), (0, _defineProperty3.default)(_ref, 'imgProps', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'sizes', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'src', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'srcSet', require('prop-types').string), _ref) : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiAvatar' })(Avatar);

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Avatar = __webpack_require__(188);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Avatar).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.styles = undefined;
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _ref;
	// A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - http://v4-alpha.getbootstrap.com/layout/flexbox-grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(8);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _requirePropFactory = __webpack_require__(211);
	
	var _requirePropFactory2 = _interopRequireDefault(_requirePropFactory);
	
	var _Hidden = __webpack_require__(200);
	
	var _Hidden2 = _interopRequireDefault(_Hidden);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func;
	
	var babelPluginFlowReactPropTypes_proptype_HiddenProps = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_HiddenProps || __webpack_require__(1).any;
	
	var GUTTERS = [0, 8, 16, 24, 40];
	var GRID_SIZES = [true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  // For the auto layouting
	  var styles = (0, _defineProperty3.default)({}, 'grid-' + breakpoint, {
	    flexBasis: 0,
	    flexGrow: 1,
	    maxWidth: '100%'
	  });
	
	  GRID_SIZES.forEach(function (size) {
	    if (typeof size === 'boolean') {
	      // Skip the first one as handle above.
	      return;
	    }
	
	    // Only keep 6 significant numbers.
	    var width = Math.round(size / 12 * Math.pow(10, 6)) / Math.pow(10, 4) + '%';
	
	    /* eslint-disable max-len */
	    // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/b0508a975d711d6b24c01f57dd5445c22699fac4/scss/mixins/_grid.scss#L69
	    /* eslint-enable max-len */
	    styles['grid-' + breakpoint + '-' + size] = {
	      flexBasis: width,
	      maxWidth: width
	    };
	  });
	
	  // No need for a media query for the first size.
	  if (breakpoint === 'xs') {
	    (0, _extends3.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	
	  GUTTERS.forEach(function (spacing, index) {
	    if (index === 0) {
	      // Skip the default style.
	      return;
	    }
	
	    styles['spacing-' + breakpoint + '-' + spacing] = {
	      margin: -spacing / 2,
	      width: 'calc(100% + ' + spacing + 'px)',
	      '& > $typeItem': {
	        padding: spacing / 2
	      }
	    };
	  });
	
	  return styles;
	}
	
	// Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	var styles = exports.styles = function styles(theme) {
	  return (0, _extends3.default)({
	    typeContainer: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	    typeItem: {
	      boxSizing: 'border-box',
	      flex: '0 0 auto',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	    },
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	    'align-xs-center': {
	      alignItems: 'center'
	    },
	    'align-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	    'align-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	    'align-xs-baseline': {
	      alignItems: 'baseline'
	    },
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    }
	  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  classes: __webpack_require__(1).object,
	  className: __webpack_require__(1).string,
	  component: __webpack_require__(1).oneOfType([__webpack_require__(1).string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_ComponentType)]),
	  container: __webpack_require__(1).bool,
	  item: __webpack_require__(1).bool,
	  align: __webpack_require__(1).oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	  direction: __webpack_require__(1).oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	  spacing: __webpack_require__(1).oneOf([0, 8, 16, 24, 40]),
	  hidden: typeof babelPluginFlowReactPropTypes_proptype_HiddenProps === 'function' ? babelPluginFlowReactPropTypes_proptype_HiddenProps : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_HiddenProps),
	  justify: __webpack_require__(1).oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around']),
	  wrap: __webpack_require__(1).oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	  xs: __webpack_require__(1).oneOfType([__webpack_require__(1).bool, __webpack_require__(1).oneOf([1]), __webpack_require__(1).oneOf([2]), __webpack_require__(1).oneOf([3]), __webpack_require__(1).oneOf([4]), __webpack_require__(1).oneOf([5]), __webpack_require__(1).oneOf([6]), __webpack_require__(1).oneOf([7]), __webpack_require__(1).oneOf([8]), __webpack_require__(1).oneOf([9]), __webpack_require__(1).oneOf([10]), __webpack_require__(1).oneOf([11]), __webpack_require__(1).oneOf([12])]),
	  sm: __webpack_require__(1).oneOfType([__webpack_require__(1).bool, __webpack_require__(1).oneOf([1]), __webpack_require__(1).oneOf([2]), __webpack_require__(1).oneOf([3]), __webpack_require__(1).oneOf([4]), __webpack_require__(1).oneOf([5]), __webpack_require__(1).oneOf([6]), __webpack_require__(1).oneOf([7]), __webpack_require__(1).oneOf([8]), __webpack_require__(1).oneOf([9]), __webpack_require__(1).oneOf([10]), __webpack_require__(1).oneOf([11]), __webpack_require__(1).oneOf([12])]),
	  md: __webpack_require__(1).oneOfType([__webpack_require__(1).bool, __webpack_require__(1).oneOf([1]), __webpack_require__(1).oneOf([2]), __webpack_require__(1).oneOf([3]), __webpack_require__(1).oneOf([4]), __webpack_require__(1).oneOf([5]), __webpack_require__(1).oneOf([6]), __webpack_require__(1).oneOf([7]), __webpack_require__(1).oneOf([8]), __webpack_require__(1).oneOf([9]), __webpack_require__(1).oneOf([10]), __webpack_require__(1).oneOf([11]), __webpack_require__(1).oneOf([12])]),
	  lg: __webpack_require__(1).oneOfType([__webpack_require__(1).bool, __webpack_require__(1).oneOf([1]), __webpack_require__(1).oneOf([2]), __webpack_require__(1).oneOf([3]), __webpack_require__(1).oneOf([4]), __webpack_require__(1).oneOf([5]), __webpack_require__(1).oneOf([6]), __webpack_require__(1).oneOf([7]), __webpack_require__(1).oneOf([8]), __webpack_require__(1).oneOf([9]), __webpack_require__(1).oneOf([10]), __webpack_require__(1).oneOf([11]), __webpack_require__(1).oneOf([12])]),
	  xl: __webpack_require__(1).oneOfType([__webpack_require__(1).bool, __webpack_require__(1).oneOf([1]), __webpack_require__(1).oneOf([2]), __webpack_require__(1).oneOf([3]), __webpack_require__(1).oneOf([4]), __webpack_require__(1).oneOf([5]), __webpack_require__(1).oneOf([6]), __webpack_require__(1).oneOf([7]), __webpack_require__(1).oneOf([8]), __webpack_require__(1).oneOf([9]), __webpack_require__(1).oneOf([10]), __webpack_require__(1).oneOf([11]), __webpack_require__(1).oneOf([12])])
	};
	
	
	function Grid(props) {
	  var _classNames;
	
	  var classes = props.classes,
	      classNameProp = props.className,
	      ComponentProp = props.component,
	      container = props.container,
	      item = props.item,
	      align = props.align,
	      direction = props.direction,
	      spacing = props.spacing,
	      hidden = props.hidden,
	      justify = props.justify,
	      wrap = props.wrap,
	      xs = props.xs,
	      sm = props.sm,
	      md = props.md,
	      lg = props.lg,
	      xl = props.xl,
	      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'component', 'container', 'item', 'align', 'direction', 'spacing', 'hidden', 'justify', 'wrap', 'xs', 'sm', 'md', 'lg', 'xl']);
	
	
	  var className = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.typeContainer, container), (0, _defineProperty3.default)(_classNames, classes.typeItem, item), (0, _defineProperty3.default)(_classNames, classes['spacing-xs-' + String(spacing)], container && spacing !== 0), (0, _defineProperty3.default)(_classNames, classes['direction-xs-' + String(direction)], direction !== Grid.defaultProps.direction), (0, _defineProperty3.default)(_classNames, classes['wrap-xs-' + String(wrap)], wrap !== Grid.defaultProps.wrap), (0, _defineProperty3.default)(_classNames, classes['align-xs-' + String(align)], align !== Grid.defaultProps.align), (0, _defineProperty3.default)(_classNames, classes['justify-xs-' + String(justify)], justify !== Grid.defaultProps.justify), (0, _defineProperty3.default)(_classNames, classes['grid-xs'], xs === true), (0, _defineProperty3.default)(_classNames, classes['grid-xs-' + String(xs)], xs && xs !== true), (0, _defineProperty3.default)(_classNames, classes['grid-sm'], sm === true), (0, _defineProperty3.default)(_classNames, classes['grid-sm-' + String(sm)], sm && sm !== true), (0, _defineProperty3.default)(_classNames, classes['grid-md'], md === true), (0, _defineProperty3.default)(_classNames, classes['grid-md-' + String(md)], md && md !== true), (0, _defineProperty3.default)(_classNames, classes['grid-lg'], lg === true), (0, _defineProperty3.default)(_classNames, classes['grid-lg-' + String(lg)], lg && lg !== true), (0, _defineProperty3.default)(_classNames, classes['grid-xl'], xl === true), (0, _defineProperty3.default)(_classNames, classes['grid-xl-' + String(xl)], xl && xl !== true), _classNames), classNameProp);
	  var gridProps = (0, _extends3.default)({ className: className }, other);
	
	  if (hidden) {
	    return _react2.default.createElement(
	      _Hidden2.default,
	      hidden,
	      _react2.default.createElement(ComponentProp, gridProps)
	    );
	  }
	
	  return _react2.default.createElement(ComponentProp, gridProps);
	}
	
	Grid.propTypes =  false ? (_ref = {
	  classes: require('prop-types').object.isRequired,
	  component: typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType.isRequired ? babelPluginFlowReactPropTypes_proptype_ComponentType.isRequired : babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType).isRequired,
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Node)
	}, (0, _defineProperty3.default)(_ref, 'classes', require('prop-types').object), (0, _defineProperty3.default)(_ref, 'className', require('prop-types').string), (0, _defineProperty3.default)(_ref, 'component', require('prop-types').oneOfType([require('prop-types').string, typeof babelPluginFlowReactPropTypes_proptype_ComponentType === 'function' ? babelPluginFlowReactPropTypes_proptype_ComponentType : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_ComponentType)])), (0, _defineProperty3.default)(_ref, 'container', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'item', require('prop-types').bool), (0, _defineProperty3.default)(_ref, 'align', require('prop-types').oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline'])), (0, _defineProperty3.default)(_ref, 'direction', require('prop-types').oneOf(['row', 'row-reverse', 'column', 'column-reverse'])), (0, _defineProperty3.default)(_ref, 'spacing', require('prop-types').oneOf([0, 8, 16, 24, 40])), (0, _defineProperty3.default)(_ref, 'hidden', typeof babelPluginFlowReactPropTypes_proptype_HiddenProps === 'function' ? babelPluginFlowReactPropTypes_proptype_HiddenProps : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_HiddenProps)), (0, _defineProperty3.default)(_ref, 'justify', require('prop-types').oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around'])), (0, _defineProperty3.default)(_ref, 'wrap', require('prop-types').oneOf(['nowrap', 'wrap', 'wrap-reverse'])), (0, _defineProperty3.default)(_ref, 'xs', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'sm', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'md', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'lg', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), (0, _defineProperty3.default)(_ref, 'xl', require('prop-types').oneOfType([require('prop-types').bool, require('prop-types').oneOf([1]), require('prop-types').oneOf([2]), require('prop-types').oneOf([3]), require('prop-types').oneOf([4]), require('prop-types').oneOf([5]), require('prop-types').oneOf([6]), require('prop-types').oneOf([7]), require('prop-types').oneOf([8]), require('prop-types').oneOf([9]), require('prop-types').oneOf([10]), require('prop-types').oneOf([11]), require('prop-types').oneOf([12])])), _ref) : {};
	Grid.defaultProps = {
	  align: 'stretch',
	  component: 'div',
	  container: false,
	  direction: 'row',
	  hidden: undefined,
	  item: false,
	  justify: 'flex-start',
	  spacing: 16,
	  wrap: 'wrap'
	};
	
	// Add a wrapper component to generate some helper messages in the development
	// environment.
	var GridWrapper = Grid; // eslint-disable-line import/no-mutable-exports
	
	if (false) {
	  var requireProp = (0, _requirePropFactory2.default)('Grid');
	
	  GridWrapper = function GridWrapper(props) {
	    return _react2.default.createElement(Grid, props);
	  };
	
	  GridWrapper.propTypes = {
	    align: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item')
	  };
	}
	
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiGrid' })(GridWrapper);

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Grid = __webpack_require__(196);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Grid).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _HiddenJs = __webpack_require__(108);
	
	var _HiddenJs2 = _interopRequireDefault(_HiddenJs);
	
	var _HiddenCss = __webpack_require__(199);
	
	var _HiddenCss2 = _interopRequireDefault(_HiddenCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(24).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Props = {
	  children: typeof babelPluginFlowReactPropTypes_proptype_Node === 'function' ? babelPluginFlowReactPropTypes_proptype_Node : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Node),
	  className: __webpack_require__(1).string,
	  only: __webpack_require__(1).oneOfType([typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint), __webpack_require__(1).arrayOf(typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint))]),
	  xsUp: __webpack_require__(1).bool,
	  smUp: __webpack_require__(1).bool,
	  mdUp: __webpack_require__(1).bool,
	  lgUp: __webpack_require__(1).bool,
	  xlUp: __webpack_require__(1).bool,
	  xsDown: __webpack_require__(1).bool,
	  smDown: __webpack_require__(1).bool,
	  mdDown: __webpack_require__(1).bool,
	  lgDown: __webpack_require__(1).bool,
	  xlDown: __webpack_require__(1).bool,
	  implementation: __webpack_require__(1).oneOf(['js', 'css'])
	};
	
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var implementation = props.implementation,
	      other = (0, _objectWithoutProperties3.default)(props, ['implementation']);
	
	
	  if (implementation === 'js') {
	    return _react2.default.createElement(_HiddenJs2.default, other);
	  }
	
	  return _react2.default.createElement(_HiddenCss2.default, other);
	}
	
	Hidden.propTypes =  false ? babelPluginFlowReactPropTypes_proptype_Props : {};
	Hidden.defaultProps = {
	  implementation: 'js',
	  xsUp: false,
	  smUp: false,
	  mdUp: false,
	  lgUp: false,
	  xlUp: false,
	  xsDown: false,
	  smDown: false,
	  mdDown: false,
	  lgDown: false,
	  xlDown: false
	};
	
	exports.default = Hidden;

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _createBreakpoints = __webpack_require__(24);
	
	var _helpers = __webpack_require__(39);
	
	var _withStyles = __webpack_require__(9);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_HiddenProps = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_HiddenProps || __webpack_require__(1).any; /* eslint-disable flowtype/require-valid-file-annotation */
	
	var babelPluginFlowReactPropTypes_proptype_Props = (0, _extends3.default)({}, babelPluginFlowReactPropTypes_proptype_HiddenProps === __webpack_require__(1).any ? {} : babelPluginFlowReactPropTypes_proptype_HiddenProps, {
	  classes: __webpack_require__(1).object
	});
	
	
	function generateStyles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	
	  return theme.breakpoints.keys.reduce(function (styles, key) {
	    styles['only' + (0, _helpers.capitalizeFirstLetter)(key)] = (0, _defineProperty3.default)({}, theme.breakpoints.only(key), hidden);
	    styles[key + 'Up'] = (0, _defineProperty3.default)({}, theme.breakpoints.up(key), hidden);
	    styles[key + 'Down'] = (0, _defineProperty3.default)({}, theme.breakpoints.down(key), hidden);
	
	    return styles;
	  }, {});
	}
	
	var styles = function styles(theme) {
	  return generateStyles(theme);
	};
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      only = props.only,
	      xsUp = props.xsUp,
	      smUp = props.smUp,
	      mdUp = props.mdUp,
	      lgUp = props.lgUp,
	      xlUp = props.xlUp,
	      xsDown = props.xsDown,
	      smDown = props.smDown,
	      mdDown = props.mdDown,
	      lgDown = props.lgDown,
	      xlDown = props.xlDown,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'classes', 'only', 'xsUp', 'smUp', 'mdUp', 'lgUp', 'xlUp', 'xsDown', 'smDown', 'mdDown', 'lgDown', 'xlDown']);
	
	
	   false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0 || (0, _keys2.default)(other).length === 1 && other.hasOwnProperty('ref'), 'Material-UI: unsupported properties received ' + (0, _keys2.default)(other).join(', ') + ' by `<Hidden />`.') : void 0;
	
	  var className = [];
	
	  for (var i = 0; i < _createBreakpoints.keys.length; i += 1) {
	    var breakpoint = _createBreakpoints.keys[i];
	    var breakpointUp = props[breakpoint + 'Up'];
	    var breakpointDown = props[breakpoint + 'Down'];
	
	    if (breakpointUp) {
	      className.push(classes[breakpoint + 'Up']);
	    }
	    if (breakpointDown) {
	      className.push(classes[breakpoint + 'Down']);
	    }
	  }
	
	  if (only) {
	    className.push(classes['only' + (0, _helpers.capitalizeFirstLetter)(only)]);
	  }
	
	  return _react2.default.createElement(
	    'span',
	    { className: className },
	    children
	  );
	}
	
	HiddenCss.propTypes =  false ? (0, _extends3.default)({}, {
	  classes: require('prop-types').object.isRequired
	}, (0, _extends3.default)({}, babelPluginFlowReactPropTypes_proptype_HiddenProps === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_HiddenProps, {
	  classes: require('prop-types').object
	})) : {};
	exports.default = (0, _withStyles2.default)(styles, { name: 'MuiHiddenCss' })(HiddenCss);

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(234);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _createBreakpoints = __webpack_require__(24);
	
	var _withWidth = __webpack_require__(76);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_HiddenProps = __webpack_require__(62).babelPluginFlowReactPropTypes_proptype_HiddenProps || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Props = (0, _extends3.default)({}, babelPluginFlowReactPropTypes_proptype_HiddenProps === __webpack_require__(1).any ? {} : babelPluginFlowReactPropTypes_proptype_HiddenProps, {
	  width: __webpack_require__(1).string.isRequired
	});
	
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      xsUp = props.xsUp,
	      smUp = props.smUp,
	      mdUp = props.mdUp,
	      lgUp = props.lgUp,
	      xlUp = props.xlUp,
	      xsDown = props.xsDown,
	      smDown = props.smDown,
	      mdDown = props.mdDown,
	      lgDown = props.lgDown,
	      xlDown = props.xlDown,
	      width = props.width,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'only', 'xsUp', 'smUp', 'mdUp', 'lgUp', 'xlUp', 'xsDown', 'smDown', 'mdDown', 'lgDown', 'xlDown', 'width']);
	
	
	   false ? (0, _warning2.default)((0, _keys2.default)(other).length === 0, 'Material-UI: unsupported properties received ' + (0, _stringify2.default)(other) + ' by `<Hidden />`.') : void 0;
	
	  var visible = true;
	
	  // `only` check is faster to get out sooner if used.
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  }
	
	  // Allow `only` to be combined with other props. If already hidden, no need to check others.
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < _createBreakpoints.keys.length; _i += 1) {
	      var _breakpoint = _createBreakpoints.keys[_i];
	      var breakpointUp = props[_breakpoint + 'Up'];
	      var breakpointDown = props[_breakpoint + 'Down'];
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	exports.default = (0, _withWidth2.default)()(HiddenJs);

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Hidden = __webpack_require__(198);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hidden).default;
	  }
	});
	
	var _HiddenJs = __webpack_require__(108);
	
	Object.defineProperty(exports, 'HiddenJs', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_HiddenJs).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var babelPluginFlowReactPropTypes_proptype_Node = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_Node || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_ChildrenArray = __webpack_require__(2).babelPluginFlowReactPropTypes_proptype_ChildrenArray || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(24).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(1).any;
	
	var babelPluginFlowReactPropTypes_proptype_HiddenProps = {
	  children: typeof $ReadOnlyArray === 'function' ? __webpack_require__(1).instanceOf($ReadOnlyArray) : __webpack_require__(1).any,
	  className: __webpack_require__(1).string,
	  only: __webpack_require__(1).oneOfType([typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint), __webpack_require__(1).arrayOf(typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : __webpack_require__(1).shape(babelPluginFlowReactPropTypes_proptype_Breakpoint))]),
	  xsUp: __webpack_require__(1).bool,
	  smUp: __webpack_require__(1).bool,
	  mdUp: __webpack_require__(1).bool,
	  lgUp: __webpack_require__(1).bool,
	  xlUp: __webpack_require__(1).bool,
	  xsDown: __webpack_require__(1).bool,
	  smDown: __webpack_require__(1).bool,
	  mdDown: __webpack_require__(1).bool,
	  lgDown: __webpack_require__(1).bool,
	  xlDown: __webpack_require__(1).bool
	};

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withTheme;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createEagerFactory = __webpack_require__(45);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _wrapDisplayName = __webpack_require__(46);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createMuiTheme = __webpack_require__(74);
	
	var _createMuiTheme2 = _interopRequireDefault(_createMuiTheme);
	
	var _themeListener = __webpack_require__(75);
	
	var _themeListener2 = _interopRequireDefault(_themeListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func; //  weak
	
	var defaultTheme = void 0;
	
	function getDefaultTheme() {
	  if (defaultTheme) {
	    return defaultTheme;
	  }
	
	  defaultTheme = (0, _createMuiTheme2.default)();
	  return defaultTheme;
	}
	
	// Provide the theme object as a property to the input component.
	function withTheme(BaseComponent) {
	  var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	  var WithTheme = function (_React$Component) {
	    (0, _inherits3.default)(WithTheme, _React$Component);
	
	    function WithTheme(props, context) {
	      (0, _classCallCheck3.default)(this, WithTheme);
	
	      var _this = (0, _possibleConstructorReturn3.default)(this, (WithTheme.__proto__ || (0, _getPrototypeOf2.default)(WithTheme)).call(this, props, context));
	
	      _this.state = {};
	      _this.unsubscribeId = null;
	
	      _this.state = {
	        // We use || as it's lazy evaluated.
	        theme: _themeListener2.default.initial(context) || getDefaultTheme()
	      };
	      return _this;
	    }
	
	    // Exposed for test purposes.
	
	
	    (0, _createClass3.default)(WithTheme, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var _this2 = this;
	
	        this.unsubscribeId = _themeListener2.default.subscribe(this.context, function (theme) {
	          _this2.setState({ theme: theme });
	        });
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (this.unsubscribeId !== null) {
	          _themeListener2.default.unsubscribe(this.context, this.unsubscribeId);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return factory((0, _extends3.default)({ theme: this.state.theme }, this.props));
	      }
	    }]);
	    return WithTheme;
	  }(_react2.default.Component);
	
	  WithTheme.displayName = (0, _wrapDisplayName2.default)(BaseComponent, 'withTheme');
	  WithTheme.Naked = BaseComponent;
	
	
	  WithTheme.contextTypes = _themeListener2.default.contextTypes;
	
	  return WithTheme;
	}

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof2 = __webpack_require__(55);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.capitalizeFirstLetter = capitalizeFirstLetter;
	exports.contains = contains;
	exports.findIndex = findIndex;
	exports.find = find;
	exports.createChainedFunction = createChainedFunction;
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function capitalizeFirstLetter(string) {
	   false ? (0, _warning2.default)(typeof string === 'string', 'Material-UI: capitalizeFirstLetter(string) expects a string argument.') : void 0;
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	} //  weak
	
	function contains(obj, pred) {
	  return (0, _keys2.default)(pred).every(function (key) {
	    return obj.hasOwnProperty(key) && obj[key] === pred[key];
	  });
	}
	
	function findIndex(arr, pred) {
	  var predType = typeof pred === 'undefined' ? 'undefined' : (0, _typeof3.default)(pred);
	  for (var i = 0; i < arr.length; i += 1) {
	    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
	      return i;
	    }
	    if (predType === 'object' && contains(arr[i], pred)) {
	      return i;
	    }
	    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
	      return arr.indexOf(pred);
	    }
	  }
	  return -1;
	}
	
	function find(arr, pred) {
	  var index = findIndex(arr, pred);
	  return index > -1 ? arr[index] : undefined;
	}
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.filter(function (func) {
	    return func != null;
	  }).reduce(function (acc, func) {
	     false ? (0, _warning2.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
	
	    if (acc === null) {
	      return func;
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, null);
	}

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	//  weak
	
	var requirePropFactory = function requirePropFactory(componentNameInError) {
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error('The property `' + propFullNameSafe + '` of ' + ('`' + componentNameInError + '` must be used on `' + requiredProp + '`.'));
	      }
	
	      return null;
	    };
	  };
	  return requireProp;
	};
	
	exports.default = requirePropFactory;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isWidthDown = exports.isWidthUp = undefined;
	
	var _defineProperty2 = __webpack_require__(7);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(117);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _debounce = __webpack_require__(98);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _createEagerFactory = __webpack_require__(45);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	var _wrapDisplayName = __webpack_require__(46);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _withTheme = __webpack_require__(51);
	
	var _withTheme2 = _interopRequireDefault(_withTheme);
	
	var _createBreakpoints = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var babelPluginFlowReactPropTypes_proptype_ComponentType = __webpack_require__(1).func; //  weak
	
	/**
	 * By default, returns true if screen width is the same or greater than the given breakpoint.
	 *
	 * @param screenWidth
	 * @param breakpoint
	 * @param inclusive - defaults to true
	 */
	var babelPluginFlowReactPropTypes_proptype_Breakpoint = __webpack_require__(24).babelPluginFlowReactPropTypes_proptype_Breakpoint || __webpack_require__(1).any;
	
	var isWidthUp = exports.isWidthUp = function isWidthUp(breakpoint, screenWidth) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(screenWidth);
	  }
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(screenWidth);
	};
	
	/**
	 * By default, returns true if screen width is the same or less than the given breakpoint.
	 *
	 * @param screenWidth
	 * @param breakpoint
	 * @param inclusive - defaults to true
	 */
	var isWidthDown = exports.isWidthDown = function isWidthDown(breakpoint, screenWidth) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(screenWidth) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	  return _createBreakpoints.keys.indexOf(screenWidth) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  function enhance(BaseComponent) {
	    var _ref2, _ref3;
	
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var Width = function (_React$Component) {
	      (0, _inherits3.default)(Width, _React$Component);
	
	      function Width() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, Width);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Width.__proto__ || (0, _getPrototypeOf2.default)(Width)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: undefined
	        }, _this.handleResize = (0, _debounce2.default)(function () {
	          _this.updateWidth(window.innerWidth);
	        }, resizeInterval), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(Width, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth(window.innerWidth);
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.handleResize.cancel();
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth(innerWidth) {
	          var breakpoints = this.props.theme.breakpoints;
	          var width = null;
	
	          /**
	           * Start with the slowest value as low end devices often have a small screen.
	           *
	           * innerWidth |0      xs      sm      md      lg      xl
	           *            |-------|-------|-------|-------|-------|------>
	           * width      |  xs   |  xs   |  sm   |  md   |  lg   |  xl
	           */
	          var index = 1;
	          while (width === null && index < breakpoints.keys.length) {
	            var currentWidth = breakpoints.keys[index];
	
	            // @media are inclusive, so reproduce the behavior here.
	            if (innerWidth < breakpoints.getWidth(currentWidth)) {
	              width = breakpoints.keys[index - 1];
	              break;
	            }
	
	            index += 1;
	          }
	
	          width = width || 'xl';
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _props = this.props,
	              initialWidth = _props.initialWidth,
	              theme = _props.theme,
	              width = _props.width,
	              other = (0, _objectWithoutProperties3.default)(_props, ['initialWidth', 'theme', 'width']);
	
	          var props = (0, _extends3.default)({
	            width: width || this.state.width || initialWidth
	          }, other);
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the client browser screen width.
	           * In order to prevent blinks and help the reconciliation of the React tree
	           * we are not rendering the child component.
	           *
	           * An alternative is to use the `initialWidth` property.
	           */
	          if (props.width === undefined) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            factory(props)
	          );
	        }
	      }]);
	      return Width;
	    }(_react2.default.Component);
	
	    Width.propTypes =  false ? (_ref2 = {
	      theme: require('prop-types').object.isRequired,
	      initialWidth: typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)
	    }, (0, _defineProperty3.default)(_ref2, 'theme', require('prop-types').object), (0, _defineProperty3.default)(_ref2, 'width', typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)), _ref2) : {};
	    Width.propTypes =  false ? (_ref3 = {
	      theme: require('prop-types').object.isRequired,
	      initialWidth: typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)
	    }, (0, _defineProperty3.default)(_ref3, 'theme', require('prop-types').object), (0, _defineProperty3.default)(_ref3, 'width', typeof babelPluginFlowReactPropTypes_proptype_Breakpoint === 'function' ? babelPluginFlowReactPropTypes_proptype_Breakpoint : require('prop-types').shape(babelPluginFlowReactPropTypes_proptype_Breakpoint)), _ref3) : {};
	
	
	    if (false) {
	      Width.displayName = (0, _wrapDisplayName2.default)(BaseComponent, 'withWidth');
	    }
	
	    return (0, _withTheme2.default)(Width);
	  }
	
	  enhance.propTypes =  false ? babelPluginFlowReactPropTypes_proptype_ComponentType === require('prop-types').any ? {} : babelPluginFlowReactPropTypes_proptype_ComponentType : {};
	  return enhance;
	}
	
	exports.default = withWidth;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(84);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(10);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(12);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(14);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(13);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(55);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(26);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(4);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(83);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(6);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(118);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : {};
	exports.default = EventListener;

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(116);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(18);
	
	var _i18n = __webpack_require__(23);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _Avatar = __webpack_require__(189);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Grid = __webpack_require__(197);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	__webpack_require__(77);
	
	__webpack_require__(686);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = (0, _reactRouter.withRouter)(function Staff(_ref) {
	  var location = _ref.location,
	      data = _ref.data;
	
	  var ln = (0, _i18n.lang)(location);
	  var members = data.allStaff.edges[0].node.staffs;
	
	  return _react2.default.createElement(
	    'div',
	    { lang: ln },
	    _react2.default.createElement(_i18n.TitleDescription, { texts: {
	        en: {
	          title: 'Committee members',
	          desc: 'Committee members of DroidKaigi 2018'
	        },
	        ja: {
	          title: '運営スタッフ',
	          desc: 'DroidKaigi 2018 運営スタッフを紹介します。'
	        }
	      } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subpage-title-wrapper bg-gray2' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'text-yellow1' },
	        _react2.default.createElement(Text, { id: 'title' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'subpage-container' },
	      _react2.default.createElement(StaffList, { members: members })
	    )
	  );
	});
	
	var StaffList = function (_React$Component) {
	  _inherits(StaffList, _React$Component);
	
	  function StaffList() {
	    _classCallCheck(this, StaffList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  StaffList.prototype.render = function render() {
	    var members = this.props.members;
	
	    return _react2.default.createElement(
	      _Grid2.default,
	      { container: true, className: 'memberList' },
	      members.map(function (member) {
	        return _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 3, sm: 2, md: 1 },
	          _react2.default.createElement(
	            'a',
	            { href: member.href },
	            _react2.default.createElement(_Avatar2.default, { className: 'memberList--avatar',
	              alt: member.name,
	              src: member.image
	            }),
	            member.name
	          )
	        );
	      })
	    );
	  };
	
	  return StaffList;
	}(_react2.default.Component);
	
	var Text = (0, _i18n2.default)({
	  en: {
	    title: 'Committee members'
	  },
	  ja: {
	    title: '運営スタッフ'
	  }
	});
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-staff-js-052e775b641efe3499cb.js